<template>
    <div class="promotion-panel posters-panel">
        <div class="panel-heading">
            <div>
                <h2>海报模板与官方海报</h2>
                <p>模板新增后默认停用，全局同时只能有一个启用模板；二维码坐标会在前后端同时校验。</p>
            </div>
            <div class="heading-actions">
                <el-button type="warning" icon="el-icon-plus" @click="templateDialogVisible = true">新增模板</el-button>
                <el-button plain icon="el-icon-picture" @click="officialDialogVisible = true">楼长官方海报</el-button>
            </div>
        </div>

        <div class="filter-line">
            <span>模板状态</span>
            <el-select v-model="status" size="small" @change="loadTemplates">
                <el-option label="全部" value="" />
                <el-option label="启用" :value="1" />
                <el-option label="停用" :value="0" />
            </el-select>
        </div>

        <el-table v-loading="loading" :data="templates" stripe empty-text="暂无海报模板">
            <el-table-column label="模板" min-width="220">
                <template slot-scope="scope">
                    <div class="template-info">
                        <img v-if="scope.row.imagePath" :src="scope.row.imagePath" :alt="scope.row.name">
                        <div>
                            <strong>{{ scope.row.name || '-' }}</strong>
                            <small>{{ scope.row.fileType || '-' }} · {{ scope.row.imageWidth || '-' }} × {{ scope.row.imageHeight || '-' }}</small>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="二维码区域" min-width="180">
                <template slot-scope="scope">
                    x {{ scope.row.qrX }} / y {{ scope.row.qrY }}<br>
                    {{ scope.row.qrWidth }} × {{ scope.row.qrHeight }}
                </template>
            </el-table-column>
            <el-table-column label="状态" width="85">
                <template slot-scope="scope">
                    <el-tag :type="isEnabled(scope.row) ? 'success' : 'info'" size="mini">
                        {{ isEnabled(scope.row) ? '启用' : '停用' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="115">
                <template slot-scope="scope">
                    <el-button v-if="!isEnabled(scope.row)" type="text" @click="changeTemplateStatus(scope.row, true)">启用</el-button>
                    <el-button v-else type="text" class="danger-text" @click="changeTemplateStatus(scope.row, false)">停用</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="新增海报模板" :visible.sync="templateDialogVisible" width="620px" @closed="resetTemplateForm">
            <el-form ref="templateForm" :model="templateForm" :rules="templateRules" label-width="120px">
                <el-form-item label="模板名称" prop="name">
                    <el-input v-model.trim="templateForm.name" maxlength="80" />
                </el-form-item>
                <el-form-item label="模板图片" prop="imagePath">
                    <div class="upload-row">
                        <el-button icon="el-icon-upload2" @click="$refs.templateFile.click()">选择 JPG / PNG</el-button>
                        <input ref="templateFile" class="file-input" type="file" accept=".jpg,.jpeg,.png,image/jpeg,image/png" @change="handleFileChange">
                        <span class="file-tip">未配置上传接口时，图片会以 Data URI 放入 imagePath。</span>
                    </div>
                    <el-input v-model.trim="templateForm.imagePath" placeholder="也可以直接填写图片路径" />
                    <img v-if="templateForm.imagePath" class="preview-image" :src="templateForm.imagePath" alt="模板预览">
                </el-form-item>
                <el-form-item label="文件类型" prop="fileType">
                    <el-select v-model="templateForm.fileType" placeholder="请选择">
                        <el-option label="JPG" value="JPG" />
                        <el-option label="PNG" value="PNG" />
                    </el-select>
                </el-form-item>
                <el-form-item label="图片尺寸" required>
                    <div class="number-row">
                        <el-form-item prop="imageWidth" label-width="0">
                            <el-input-number v-model="templateForm.imageWidth" :min="1" controls-position="right" />
                        </el-form-item>
                        <span>×</span>
                        <el-form-item prop="imageHeight" label-width="0">
                            <el-input-number v-model="templateForm.imageHeight" :min="1" controls-position="right" />
                        </el-form-item>
                        <span>px</span>
                    </div>
                </el-form-item>
                <el-form-item label="二维码坐标与尺寸" required>
                    <div class="number-grid">
                        <label>x <el-input-number v-model="templateForm.qrX" :min="0" controls-position="right" /></label>
                        <label>y <el-input-number v-model="templateForm.qrY" :min="0" controls-position="right" /></label>
                        <label>宽 <el-input-number v-model="templateForm.qrWidth" :min="1" controls-position="right" /></label>
                        <label>高 <el-input-number v-model="templateForm.qrHeight" :min="1" controls-position="right" /></label>
                    </div>
                    <p class="form-tip">二维码区域必须完全落在图片边界内。</p>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="templateDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="saving" @click="createTemplate">保存（默认停用）</el-button>
            </span>
        </el-dialog>

        <el-dialog title="楼长官方海报" :visible.sync="officialDialogVisible" width="520px">
            <el-form :inline="true" size="small" @submit.native.prevent="loadOfficialPoster">
                <el-form-item label="任职 ID">
                    <el-input v-model.trim="officialAppointmentId" placeholder="请输入 appointmentId" />
                </el-form-item>
                <el-button type="primary" @click="loadOfficialPoster">生成海报</el-button>
            </el-form>
            <div v-loading="officialLoading" class="official-poster">
                <img v-if="officialImage" :src="officialImage" alt="楼长官方海报">
                <el-empty v-else description="输入任职 ID 后生成官方海报" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/tool/request";
import API from "@/tool/api";
import {
    asList,
    getResultData,
    getResultMessage,
    isResultSuccess,
} from "@/tool/result";

const jsonConfig = { headers: { "Content-Type": "application/json" } };

export default {
    data() {
        return {
            templates: [],
            status: "",
            loading: false,
            saving: false,
            templateDialogVisible: false,
            officialDialogVisible: false,
            officialLoading: false,
            officialAppointmentId: "",
            officialImage: "",
            templateForm: {
                name: "",
                imagePath: "",
                fileType: "",
                imageWidth: 0,
                imageHeight: 0,
                qrX: 0,
                qrY: 0,
                qrWidth: 160,
                qrHeight: 160,
            },
            templateRules: {
                name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
                imagePath: [{ required: true, message: "请选择或填写模板图片", trigger: "change" }],
                fileType: [{ required: true, message: "请选择文件类型", trigger: "change" }],
                imageWidth: [{ required: true, message: "请输入图片宽度", trigger: "change" }],
                imageHeight: [{ required: true, message: "请输入图片高度", trigger: "change" }],
            },
        };
    },
    mounted() {
        this.loadTemplates();
    },
    methods: {
        idOf(item) {
            return item && (item.templateId || item.id);
        },
        isEnabled(item) {
            return item && (item.status === 1 || item.status === "1" || item.enabled === true);
        },
        loadTemplates() {
            this.loading = true;
            const params = {};
            if (this.status !== "") params.status = this.status;
            request.get(API.promotion.posterTemplates.list, { params })
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "海报模板加载失败"));
                        return;
                    }
                    this.templates = asList(response);
                })
                .catch((error) => this.$message.error(getResultMessage(error, "海报模板加载失败")))
                .finally(() => {
                    this.loading = false;
                });
        },
        resetTemplateForm() {
            this.templateForm = {
                name: "",
                imagePath: "",
                fileType: "",
                imageWidth: 0,
                imageHeight: 0,
                qrX: 0,
                qrY: 0,
                qrWidth: 160,
                qrHeight: 160,
            };
            if (this.$refs.templateForm) this.$refs.templateForm.clearValidate();
        },
        handleFileChange(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) return;
            const fileType = file.type === "image/png" ? "PNG" : file.type === "image/jpeg" ? "JPG" : "";
            if (!fileType) {
                this.$message.error("模板仅支持 JPG、PNG 文件");
                event.target.value = "";
                return;
            }
            const reader = new FileReader();
            reader.onload = (loadEvent) => {
                const image = new Image();
                image.onload = () => {
                    this.templateForm.imagePath = loadEvent.target.result;
                    this.templateForm.fileType = fileType;
                    this.templateForm.imageWidth = image.naturalWidth;
                    this.templateForm.imageHeight = image.naturalHeight;
                };
                image.src = loadEvent.target.result;
            };
            reader.readAsDataURL(file);
        },
        validateCoordinates() {
            const form = this.templateForm;
            return form.qrX >= 0 && form.qrY >= 0 && form.qrWidth > 0 && form.qrHeight > 0 &&
                form.qrX + form.qrWidth <= form.imageWidth && form.qrY + form.qrHeight <= form.imageHeight;
        },
        createTemplate() {
            this.$refs.templateForm.validate((valid) => {
                if (!valid) return;
                if (!this.validateCoordinates()) {
                    this.$message.error("二维码区域必须完全落在图片边界内");
                    return;
                }
                this.saving = true;
                // 不提交 status，服务端会按契约将新模板默认设为停用。
                request.post(API.promotion.posterTemplates.create, this.templateForm, jsonConfig)
                    .then((response) => {
                        if (!isResultSuccess(response)) {
                            this.$message.error(getResultMessage(response, "海报模板创建失败"));
                            return;
                        }
                        this.$message.success("模板创建成功，当前为停用状态");
                        this.templateDialogVisible = false;
                        this.loadTemplates();
                    })
                    .catch((error) => this.$message.error(getResultMessage(error, "海报模板创建失败")))
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },
        changeTemplateStatus(template, enable) {
            const api = enable ? API.promotion.posterTemplates.enable : API.promotion.posterTemplates.disable;
            request({ method: "PUT", url: api(this.idOf(template)) })
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, enable ? "模板启用失败" : "模板停用失败"));
                        return;
                    }
                    this.$message.success(enable ? "模板已启用" : "模板已停用");
                    this.loadTemplates();
                })
                .catch((error) => this.$message.error(getResultMessage(error, enable ? "模板启用失败" : "模板停用失败")));
        },
        loadOfficialPoster() {
            if (!this.officialAppointmentId) {
                this.$message.warning("请输入任职 ID");
                return;
            }
            this.officialLoading = true;
            this.officialImage = "";
            request.get(API.promotion.appointments.poster(this.officialAppointmentId))
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "官方海报加载失败"));
                        return;
                    }
                    const data = getResultData(response) || {};
                    this.officialImage = data.imageData || "";
                })
                .catch((error) => this.$message.error(getResultMessage(error, "官方海报加载失败")))
                .finally(() => {
                    this.officialLoading = false;
                });
        },
    },
};
</script>

<style scoped>
.panel-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 18px;
}

.panel-heading h2 {
    margin: 0;
    font-size: 22px;
}

.panel-heading p {
    margin: 8px 0 0;
    color: #909399;
}

.heading-actions {
    display: flex;
    gap: 10px;
}

.filter-line {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
    color: #606266;
}

.template-info {
    display: flex;
    align-items: center;
    gap: 12px;
}

.template-info img {
    width: 54px;
    height: 42px;
    object-fit: cover;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.template-info strong,
.template-info small {
    display: block;
}

.template-info small {
    margin-top: 5px;
    color: #909399;
}

.danger-text {
    color: #f56c6c;
}

.upload-row,
.number-row,
.number-grid {
    display: flex;
    align-items: center;
    gap: 10px;
}

.file-input {
    display: none;
}

.file-tip,
.form-tip {
    color: #909399;
    font-size: 12px;
}

.preview-image {
    display: block;
    max-width: 180px;
    max-height: 120px;
    margin-top: 12px;
    object-fit: contain;
    border: 1px solid #ebeef5;
}

.number-grid {
    flex-wrap: wrap;
}

.number-grid label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.form-tip {
    margin: 8px 0 0;
}

.official-poster {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 280px;
    margin-top: 8px;
}

.official-poster img {
    max-width: 100%;
    max-height: 650px;
    object-fit: contain;
}

@media (max-width: 700px) {
    .panel-heading {
        display: block;
    }

    .heading-actions {
        margin-top: 16px;
    }

    .upload-row {
        align-items: flex-start;
        flex-direction: column;
    }
}
</style>
